module.exports = __webpack_public_path__ + "img/flag_outline.e763eeb9.svg";